import React from 'react';
import ScrollToTop from './components/ScrollToTop';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import HealthcareAI from './pages/HealthcareAI';
import SalusIAM from './pages/SalusIAM';
import Cybersecurity from './pages/Cybersecurity';
import Solutions from './pages/Solutions';
import Contact from './pages/Contact';
import Career from './pages/Career';
import Chatbot from './pages/Chatbot';
import AIFirewall from './pages/AIFirewall';
import EnterpriseRisk from './pages/EnterpriseRisk';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Resources from './pages/Resources';
import SapienShield from './pages/SapienShield';

import Partners from './pages/Partners';
import Working from './pages/Working';
import Stack from './pages/Stack';

import Meaning from './pages/meaning';
import Mission from './pages/mission';
import Value from './pages/value';
import Team from './pages/team';
import Approach from './pages/approach';
import JoinUs from "./pages/JoinUs";
import Capabilities from './pages/Capabilities';


function App() {
  return (
    <Router>
      <ScrollToTop />

      <div className="app-shell">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/healthcare-ai" element={<HealthcareAI />} />
          <Route path="/salus-iam" element={<SalusIAM />} />
          <Route path="/cybersecurity" element={<Cybersecurity />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/ai-firewall" element={<AIFirewall />} />
          <Route path="/enterprise-ai-risk" element={<EnterpriseRisk />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/working" element={<Working />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/stack" element={<Stack />} />

          <Route path="/meaning" element={<Meaning />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/value" element={<Value />} />
          <Route path="/team" element={<Team />} />
          <Route path="/approach" element={<Approach />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/sapienshield" element={<SapienShield />} />
        </Routes>

        <Chatbot />
      </div>
    </Router>
  );
}

export default App;
